import type { AppIconProps } from '../Icons.types';

export const AppSchoolIcon = (props: AppIconProps) => {
  const { className, ...rest } = props;

  return (
    <svg
      {...rest}
      className={className}
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.75 4.75L10.75 0.75L0.75 4.75L10.75 8.75L20.75 4.75ZM20.75 4.75V10.75M4.75 6.35001V11.75C4.75 12.5457 5.38214 13.3087 6.50736 13.8713C7.63258 14.4339 9.1587 14.75 10.75 14.75C12.3413 14.75 13.8674 14.4339 14.9926 13.8713C16.1179 13.3087 16.75 12.5457 16.75 11.75V6.35001"
        stroke="#737781"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
